import React from 'react';
import { motion } from 'framer-motion';
import AnimatedText from './AnimatedText';

const stats = [
  { value: '3×', label: 'Avg. engagement lift' },
  { value: '120%+', label: 'Organic follower growth' },
  { value: '1M+', label: 'Combined impressions' },
  { value: '10+', label: 'Brands served' },
];

const MissionStats = () => {
  return (
    <section
      data-testid="mission-stats"
      className="py-24 sm:py-32 px-6 sm:px-8 lg:px-12 bg-[#F4F4F3]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-20">
          <div className="lg:col-span-4">
            <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#AA94FF]">
              Our mission
            </p>
          </div>
          <AnimatedText
            as="h2"
            className="lg:col-span-8 text-3xl sm:text-5xl lg:text-6xl font-black tracking-[-0.03em] leading-[1.02] text-[#1C1917]"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            y={50}
          >
            Turn social media into a consistent, high-performing growth channel — not a guessing game.
          </AnimatedText>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white border border-[#1C1917]/5 rounded-3xl p-8 hover:border-[#AA94FF] transition-colors"
            >
              <p
                className="text-5xl sm:text-6xl font-black tracking-[-0.04em] text-[#AA94FF] mb-3"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {s.value}
              </p>
              <p className="text-sm text-[#78716C] font-medium">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionStats;
